import axios from "axios";
import GlobalURL from "./global";
import React from "react";

let token = localStorage.getItem("token");
let tokenData = token ? JSON.parse(token) : null;

const httpclient = axios.create({
  baseURL: GlobalURL[0].url,
  headers: {
    Authorization: tokenData ? `Bearer ${tokenData}` : "",
  },
});

// We'll initialize this later with the actual notification function
let showNotification = null;

export const setNotificationFunction = (notificationFn) => {
  showNotification = notificationFn;
};

httpclient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {

      
      // Show notification if the function is available
      if (showNotification) {
        showNotification(error.response.data.message, "error");
      }
      
      
      
      // redirect to login
      // setTimeout(() => {
      //   window.location.href = "/login";
      // }, 2000);
      localStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default httpclient;